module.exports = __webpack_public_path__ + "img/pp-51.54a98360.jpg";